export default function get_title(question, lang = "default") {
    return typeof question.title === "object"
        ? question.title?.[lang] || question.title?.default || question.name
        : question.title || question.name;
}
